// removed by extract-text-webpack-plugin
module.exports = {"AccessoryInfoContainer":"AccessoryInfoContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-info-container/styles.css
// module id = 876
// module chunks = 0 1